import { Keys } from '../types';

const keys: Keys = {
  infura: 'fcfe076ef8204cfabd9fb762dcf32afb',
  alchemy: 'trix72l2oM0eJK0UB8YfR',
  graph: 'a84caa9e5c322a2faec24ad89ccb9d28',
  balancerApi: 'da2-7a3ukmnw7bexndpx5x522uafui',
};

export default keys;
